import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ApiGetSuccessResponse } from '../models/common/api-get-success-response';
import { Layout } from '../models/entities/layout';
import { EventType } from '../models/entities/event-type';

@Injectable({
  providedIn: 'root',
})
export class EventTypesService {
  constructor(private apiService: ApiService) {}

  findAll(): Observable<ApiGetSuccessResponse<EventType[]>> {
    return this.apiService.get('event-types');
  }
}
